import type React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { useAuthStore } from '@/store/useAuthStore'

export const ProtectedRoute: React.FC = () => {
  const hydrating = useAuthStore((s) => s.hydrating)
  const isAuthenticated = useAuthStore((s) => !!s.accessToken)

  if (hydrating) return null

  if (!isAuthenticated) {
    return <Navigate to="/" replace />
  }

  return <Outlet />
}
